/**
 * Controlled service-worker registration (plan section 8: never activate an update
 * mid-save). vite-plugin-pwa is configured with registerType 'prompt' and
 * injectRegister false, so registration is explicit here and production-only.
 * Phase 4 replaces the confirm() with an in-app "Update ready" banner.
 */
export async function initPwa(): Promise<void> {
  if (!import.meta.env.PROD) return
  const { registerSW } = await import('virtual:pwa-register')

  let updateSW: (reloadPage?: boolean) => Promise<void> = async () => {}
  updateSW = registerSW({
    onNeedRefresh() {
      const ok = window.confirm(
        'A new version of Mobile Trading Pro is ready. Finish any in-progress save, then update now?',
      )
      if (ok) void updateSW(true)
    },
    onOfflineReady() {
      // Offline shell cached; the app can now run without a connection.
    },
    onRegisterError(err) {
      console.error('Service worker registration failed', err)
    },
  })
}
